<template>
  <HeadlineComponent>Veranstaltung erstellen</HeadlineComponent>
  <Form
    class="form-horizontal"
    @submit="onSubmit"
    :initialValues="event"
    v-slot="{ setFieldValue }"
  >
    <EventForm :event="event" :setFieldValue="setFieldValue"></EventForm>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading"
        >Anlegen</LoadingButton
      >
    </div>
  </Form>
</template>

<script>
import eventService from "@/services/event.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import moment from "moment";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { Form } from "vee-validate";
import EventForm from "@/components/EventForm.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "CreateEventView",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { HeadlineComponent, Form, EventForm, LoadingButton },
  data() {
    return {
      event: {
        latitude: 51.16,
        longitude: 10.45,
        min_required_shifts: 1,
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async onSubmit(form, actions) {
      this.loading = true;
      try {
        let e = JSON.parse(JSON.stringify(form));
        e.start_date = moment(e.start_date, "YYYY-MM-DDTHH:mm").format();
        const tsd = moment(e.ticket_send_date, "YYYY-MM-DDTHH:mm");
        e.ticket_send_date = tsd.isValid() ? tsd.format() : null;
        const ed = moment(e.end_date, "YYYY-MM-DDTHH:mm");
        e.end_date = ed.isValid() ? ed.format() : null;
        e.min_required_shifts = Number(e.min_required_shifts);
        var response = await eventService.create(e);
        window.scrollTo(0, 0);
        this.addAlert("success", "Event erfolgreich erstellt.");
        this.$router.push("/events/" + response.data.id);
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
